import styled, { css } from 'styled-components'
import { CARD_PREVIEW_HEIGHT } from 'config/cardConfig'
import { CardPreviewProps } from './CardPreview'

const backgroundImage = css`
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`

export const Preview = styled.div<CardPreviewProps>`
  position: relative;
  overflow: hidden;
  height: ${CARD_PREVIEW_HEIGHT}px;
  transition: transform 0.5s ease-out;

  ${({ theme }) => `
    ${theme.pattern}
    border-radius: ${theme.borderRadius.base} ${theme.borderRadius.base} 0 0;
    background-color: ${theme.color.oceanDark};
  `}

  ${({ defaultUrl }) =>
    defaultUrl &&
    `
    background-image: url(${defaultUrl});
    ${backgroundImage}
  `}
  
  ${({ theme, url }) =>
    url &&
    `
    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background-image: url(${url});
      ${backgroundImage}
    }
  `}
`
